module.exports = __webpack_public_path__ + "img/理财.519b83cf.png";